import { useCallback, useState } from 'react';

import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { PaginationState } from '@tanstack/react-table';

import { DataGrid } from 'src/common/DataGrid';
import { usePagination } from 'src/common/DataGrid/usePagination';
import {
  InvoicePaymentLinkRead,
  useInvoicesPaymentLinkListQuery,
} from 'src/common/external/bambi-api/bambiApi';

import { paymentLinksColumns } from './columns';
import { PaymentLinksEmptyState } from './PaymentLinksEmptyState';

export function PaymentLinksDataGrid() {
  const [currentPage, setCurrentPage] = useState(1);
  const {
    data: paymentLinks,
    isLoading,
    refetch,
  } = useInvoicesPaymentLinkListQuery({
    page: currentPage,
  });

  const handlePaginationUpdate = useCallback(
    (state: PaginationState) => {
      setCurrentPage(state.pageIndex + 1);
      refetch();
    },
    [refetch]
  );

  const { pagination, handlePaginationChange } = usePagination(
    handlePaginationUpdate
  );

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <DataGrid<InvoicePaymentLinkRead>
      tableId="payment-links"
      columns={paymentLinksColumns}
      data={paymentLinks?.results ?? []}
      emptyState={<PaymentLinksEmptyState />}
      totalCount={paymentLinks?.count ?? 0}
      pagination={pagination}
      handlePaginationChange={handlePaginationChange}
    />
  );
}
